// 返回当前环境网关链接
export function fetchEvn() {
    let domainUrl = location.origin;
    let env;
    if (domainUrl.includes("hdbqa.emmars")) {
        env = 'qa'
    } else if (domainUrl.includes("hdbpre.emmars")) {
        env = 'pre'
    } else if (domainUrl.includes("hdbgr.emmars")) {
        env = 'gr'
    } else if (domainUrl.includes("hdb.emmars")) {
        env = 'prd'
    } else {
        //本地项目 接口环境 随意改 单
        env = 'qa'
    }
    return env;
}

export const api = {
    qa: `https://chg.qa.enmonster.com`,
    pre: `https://chg.pre.enmonster.com`,
    gr: `https://chg.gr.enmonster.com`,
    prd: `https://chg.enmonster.com`
}

// 打点 api
export const vrsApi = {
    qa: `https://vrs.qa.enmonster.com`,
    pre: `https://vrs.pre.enmonster.com`,
    gr: `https://vrs.gr.enmonster.com`,
    prd: `https://vrs.enmonster.com`
}

// 验证手机号
export function isPhoneNo(phone) {
    var pattern = /^1\d{10}$/;
    return pattern.test(phone);
}

// 验证中文名称
export function isChinaName(name) {
    var pattern = /^[\u4E00-\u9FA5]{1,6}$/;
    return pattern.test(name);
}

// 验证身份证
export function isCardNo(card) {
    var pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return pattern.test(card);
}

// 拨打电话格式重置
export function dialed(phone) {
    return "tel:" + phone;
}

// 验证密码为 字母加数字
export function isPassword(password) {
    const pattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/;
    return pattern.test(password);
}
// 验证 纯数字
export function isInumber(number) {
    const pattern = /^[0-9]*$/;
    return pattern.test(number);
}
// 邮箱检验
export function isEmail(email) {
    const pattern = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    return pattern.test(email);
}
// 字母或数字
export function isNumbOrEn(email) {
    const pattern = /^[a-zA-Z\d]+$/;
    return pattern.test(email);
}
// 中文或字母或数字
export function isCnOrNumbOrEn(email) {
    const pattern = /^[\u4E00-\u9FA5a-zA-Z\d]+$/;
    return pattern.test(email);
}
//纯字母
export function isLetter(str) {
    const reg = /^[a-zA-Z]*$/;
    return reg.test(str)
}
//小写字母校验 + 数字
export function isLowerEnNum(str) {
    const reg = /^[a-z0-9]*$/;
    return reg.test(str)
}
//小写字母校验 + 数字
export function isLowerEn(str) {
    const reg = /^[a-z]*$/;
    return reg.test(str)
}
//字母大小写 + 数字
export function isLetterNumb(str) {
    const reg = /^[A-Z]+\d+$/;
    // console.log(reg.test(str))
    return reg.test(str)
}
//非符号
export function isNoSign(str) {
    const reg = /^[\u4E00-\u9FA50-9A-Za-z]*$/;
    return reg.test(str)
}
// url
export function isUrl(url) {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?*'\\+&%$#=~_-]+))*$/;
    return reg.test(url)
}

//时间戳 转 日期
export function datePurify(tdate) {
    var date = new Date(tdate);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
    var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
    return Y + M + D + h + m + s;
}


//动态加载JS
export function loadScript(url) {
    return new Promise(resolve => {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = url;
        s.charset = "utf-8";
        document.head.appendChild(s);
        s.onload = () => {
            resolve()
        }
    })
}

//随机生成一个ID(年月日+8位随机数)
export function generateRandomId() {
    let [_date, _id] = [new Date(), ""];
    _id = 'xxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    _id = _date.getFullYear() + "" + (_date.getMonth() > 8 ? (_date.getMonth() + 1) : "0" + (1 + _date.getMonth())) + "" + (_date.getDate() > 9 ? _date.getDate() : "0" + _date.getDate()) + _id;
    return _id;
}

//本地存储
export function localStorage(key, value) {
    if (arguments.length === 0) {
        config.log("没有参数");
        return;
    }
    if (!window || !window.localStorage) {
        //TODO: 修改弹窗提示
        // this.showDialog({dialogMsg:"您开启了秘密浏览或无痕浏览模式，请关闭!"});
        return;
    }
    if (arguments.length === 1 || typeof (value) === "undefined") {
        return window.localStorage.getItem(key);
    } else if (value === null || value === '') {
        window.localStorage.removeItem(key);
    } else if (typeof (value) === "object") {
        window.localStorage.setItem(key, JSON.stringify(value));
    } else {
        window.localStorage.setItem(key, value);
    }
}


export function timeSubtraction(starTime) {
    let startDate = new Date(starTime.replace(/-/g, "/"));
    let nowDate = new Date();
    let date = startDate.getTime() - nowDate.getTime();
    // console.log('date / (24 * 3600 * 1000)--->',date / (24 * 3600 * 1000))
    let days = Math.floor(date / (24 * 3600 * 1000))
    // console.log('dateDiff-----'+dateDiff)
    //计算出小时数

    let leave1 = date % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / (3600 * 1000)) * 60 * 60
    //计算相差分钟数
    let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / (60 * 1000)) * 60
    //计算相差秒数
    let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
    let seconds = Math.round(leave3 / 1000)
    seconds = seconds + hours + minutes;
    // console.log(" 相差 " + days + "天 " + ' 相差 ' + seconds + '秒')
    return { days: days, seconds: seconds }
}

export function encodeSearchParams(obj, parentObj) {
    // Object.keys(obj).forEach((key) => {
    let params = ''
    for (let key in obj) {
        let value = obj[key]
        let t = typeof value
        // 如果值为undefined我们将其置空
        if (t === 'undefined') {
            value = ''
        } else if (t === 'string' || t === 'number' || t === 'boolean') {
            if (parentObj) {
                params = params + '&' + parentObj + '[' + key + ']' + '=' + value
            } else {
                params = params + '&' + key + '=' + value
            }
            continue
        } else {
            encodeSearchParams(value, key)
        }
    }
    return params
}

export function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

export const ModalHelper = ((bodyCls) => {
    let scrollTop;
    return {
        afterOpen: function () {
            scrollTop = document.scrollingElement.scrollTop;
            document.body.classList.add(bodyCls);
            console.log('afterOpen', document.body.classList)
            document.body.style.top = -scrollTop + 'px';
        },
        beforeClose: function () {
            document.body.classList.remove(bodyCls);
            console.log('beforeClose', document.body.classList)
            // scrollTop lost after set position:fixed, restore it back.
            document.scrollingElement.scrollTop = scrollTop;
        }
    };
})('dialog-open');

import md5 from './md5';
const newCryptoJS = require('./crypto')
/**
 * 加签规则
 * @param {*} path 请求地址UrlPath，不包含 Query 部分
 * @param {*} method 请求方式 大写
 * @param {*} body  请求体参数
 * @param {*} headers header
 */
export function getSign(path, method, body = {}, headers = {}) {
    let sign = '', // 最后加密生成
      salt = 'HfYSflT', // 密钥 // 测试
      time = new Date().getTime(),
      nonce = generateUUID(),
      header = {},
      query = {},
      headerStr = '',
      {
        noSignEn = false //判断body 是否进行验签  true 进行
      } = body
  
    if (!path) {
      throw new Error('path 必传')
    }
  
    if (!method) {
      throw new Error('method 必传')
    }
  
    if (typeof headers != 'object') {
      headers = {}
    }
  
    header = Object.assign(header, headers)
    header['x-signature-nonce'] = nonce
    header['x-signature-timestamp'] = time
    header = ksort(header)
  
    for (let key in header) {
      headerStr = `${headerStr}${key.toLocaleLowerCase()}:${encodeURIComponent(header[key])}` + '\n'
    }
    headerStr = headerStr.substr(0, headerStr.length - 1);
    if (typeof body != 'object') {
      body = {}
    }
  
  
    method = method.toLocaleUpperCase()
  
    if (method == 'GET') {
      query = ksort(JSON.parse(JSON.stringify(body)))
    }
    let stringToSign = `${headerStr}\n${method}\n${path}`
    if ((method == 'GET' || Object.keys(query)) && !noSignEn) {
      let queryStr = ''
      for (let i in query) {
        queryStr = `${queryStr}${i.toLocaleLowerCase()}:${encodeURIComponent(header[i])}` + '\n'
      }
      queryStr = queryStr.substr(0, queryStr.length - 1)
      stringToSign = `${stringToSign}\n${queryStr}` // /n是否去掉
    }
    if (method == 'POST' && !noSignEn) {
      body = JSON.stringify(body).toString()
      let bodyMd5 = md5.hexMD5(body)
      stringToSign = `${stringToSign}${bodyMd5}`
    }
    sign = newCryptoJS.CryptoJS.HmacSHA256(stringToSign, salt).toString().toUpperCase()
    header['x-signature'] = sign
  
    return {
      header,
      sign,
      time,
      nonce
    }
}


/**
 * 按照字母排序
 * @param {*} arys 
 */
function ksort (arys) {
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newkey = Object.keys(arys).sort();
    //console.log('newkey='+newkey);
    var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {
      //遍历newkey数组
      newObj[newkey[i]] = arys[newkey[i]];
    }
    return newObj; //返回排好序的新对象
}


function generateUUID() {
    let uuid = '',
        d = new Date().getTime()

    uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })

    return uuid
}